import React, { Component } from 'react';
import Select from "react-select";
import { Button, Input } from "reactstrap"
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import InputMask from "react-input-mask";
import commonApiFunction, { uploadImageFileFunction } from "../../../api/ApiController";
import { Growl } from 'primereact/growl';
import HeaderRegistration from '../../common/headers/header-registration';
import FooterCustom from "../../common/footers/footer-custom";
import { Helmet } from 'react-helmet'
import SimpleReactValidator from 'simple-react-validator';

const documentTypeOptions = [
    { value: "SocialSecurity", label: "SSN", color: "#00B8D9", isFixed: true },
    { value: "DrivingLicenseID", label: "Driving License", color: "#0052CC", isFixed: true },
    { value: "StateID", label: "State ID", color: "#5243AA", isFixed: true },
]

const locationOptions = [
    { value: "Egg Harbor Township - 3205 Fire Rd, Suite 1, Egg Harbor Township, NJ 08234", label: "Egg Harbor Township - 3205 Fire Rd, Suite 1, Egg Harbor Township, NJ 08234", color: "#0052CC", isFixed: true },
    { value: "Oakhurst - 1912 NJ-35, Oakhurst, NJ 07755", label: "Oakhurst - 1912 NJ-35, Oakhurst, NJ 07755", color: "#00B8D9", isFixed: true },


]
const genderOptions = [
    { value: "Male", label: "Male", color: "#00B8D9", isFixed: true },
    { value: "Female", label: "Female", color: "#0052CC", isFixed: true },
    { value: "Other", label: "Other", color: "#5243AA", isFixed: true },
]

const testTypeOptions = [
    { value: "Covid-19 PCR by Swab", label: "Covid-19 PCR by Swab", color: "#0052CC", isFixed: true },
    { value: "Covid-19 Antibody test", label: "Covid-19 Antibody test", color: "#00B8D9", isFixed: true },
    { value: "Covid-19 PCR by Swab & Covid-19 Antibody test", label: "Both", color: "#00B8D9", isFixed: true },


]

class PreRegistration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showHideDocument: false,
            rg_name: '',
            rg_dob: '',
            rg_email: '',
            rg_phone: '',
            rg_gender: '',
            rg_test_location: '',
            rg_address: '',
            rg_insurance_image: '',
            rg_document_type: '',
            rg_ssn: '',
            rg_document_type_image: '',
            rg_consent_accept: false,
            validateDocumentImage: 0,
            valgender: [],
            valTestLocation: [],
            rg_consent_accept_submit: false,
            rg_physician_center_name: '',
            rg_test_day: '',
            rg_test_type: '',
            rg_test_time: '09:15',
            valTestType: [],
            rg_physician_name: '',
            disabledButton: false,
            actualSsn: "",
            maskedSsn: "",
            rg_procedure_date: '',
            rg_name_of_surgeon: '',
            rg_surgery_center_name: '',
            rg_is_preoperative: false,
            IsPreOperativeTesting:0,

        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                ssn: { 
                  message: 'The :attribute must be a valid SSN.',
                  rule: function(val, params, validator) { 
                    return validator.helpers.testRegex(val,/^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/i) && params.indexOf(val) === -1
                  }
                }
            }

        });
        this.handleChangeSSN = this.handleChangeSSN.bind(this);
    }

    handleChangeSSN = (event) => {
        const prevValue = this.state.maskedSsn;
        const newValue = event.target.value;
        let actual = this.state.actualSsn;
        if (newValue.length > 11) {
            return;
        }
        if (newValue.length > prevValue.length) {
            let newChar = newValue.split("").pop();
            actual = `${actual}${newChar}`;
        }
        else {
            const charsRemovedCount = prevValue.length - newValue.length;
            actual = actual.substr(0, actual.length - charsRemovedCount);
        }
        this.setState({
            actualSsn: actual,
            maskedSsn: this.starredMask(actual),
            rg_ssn: actual,
        });

    }
    starredMask(ssn, showLast4 = true) {
        let valueHidden = ssn.replace(/[\d]/g, "*");
        if (valueHidden.length <= 3) {
            return valueHidden;
        }
        if (valueHidden.length <= 5) {
            return valueHidden.slice(0, 3) + "-" + valueHidden.slice(3, 5);
        }
        if (showLast4) {
            return (
                valueHidden.slice(0, 3) +
                "-" +
                valueHidden.slice(3, 5) +
                "-" +
                ssn.substr(5)
            );
        } else {
            return (
                valueHidden.slice(0, 3) +
                "-" +
                valueHidden.slice(3, 5) +
                "-" +
                valueHidden.slice(5, 9)
            );
        }
    }

//     handleBlurSSN = (event)=>{
//         const keyCode = event.keyCode || event.which;
//    const keyValue = String.fromCharCode(keyCode);
//     if (/\+|-/.test(keyValue)){
//         event.preventDefault();
//         console.log("helllo");
//     }
//     else{
//         console.log("hiiiii");
//     }
     
//     }

    changeDocumentType = async e => {
        await this.setState({ rg_document_type: e.value, valDocumentType: [{ label: e.label, value: e.value }] })


        if (this.state.rg_document_type == 'SocialSecurity') {
            this.setState({ showHideDocument: true, validateDocumentImage: 1 })

        }
        else {
            this.setState({ showHideDocument: false, validateDocumentImage: 2 })

        }
    }

    handleTestingTime = (selectedDates, dateStr, instance) => {
        this.setState({ rg_test_time: dateStr })
    }



    handleAggrement = async e => {
        await this.setState({ rg_consent_accept: !this.state.rg_consent_accept })

        if (this.state.rg_consent_accept === true) {
            this.setState({ rg_consent_accept_submit: true })
        }
        else {
            this.setState({ rg_consent_accept_submit: false })
        }
        // console.log(this.state.rg_consent_accept);
    }

    handleIsOperative = async e => {
        await this.setState({ rg_is_preoperative: !this.state.rg_is_preoperative })
       // console.log(this.state.rg_is_preoperative);
       if (this.state.rg_is_preoperative === true) {
        this.setState({ IsPreOperativeTesting:1})
       }
        else {
            this.setState({ IsPreOperativeTesting:0})

         }

    }

    submitRegistration = async e => {
        e.preventDefault();
       // console.log(this.state);
        if (this.validator.allValid()) {
            this.validator.purgeFields();
            this.setState({ disabledButton: true, })
            let action = "PreRegistration";
            let fd = new FormData();
            fd.append('action', action);
            fd.append('Name', this.state.rg_name);
            fd.append('DOB', this.state.rg_dob);
            fd.append('Address', this.state.rg_address);
            fd.append('Phone', this.state.rg_phone);
            fd.append('EmailID', this.state.rg_email);
            fd.append('TestLocation', this.state.rg_test_location);
            fd.append('Gender', this.state.rg_gender);
            fd.append('DocumentType', this.state.rg_document_type);
            fd.append('filename1', this.state.rg_insurance_image);
            fd.append('filename2', this.state.rg_document_type_image);
            fd.append('SocialSecurity', this.state.rg_ssn);
            fd.append('PhysicianName', this.state.rg_physician_name);
            fd.append('PhysicianCenterName', this.state.rg_physician_center_name);
            fd.append('TestDate', this.state.rg_test_day);
            fd.append('TestTime', this.state.rg_test_time);
            fd.append('TestName', this.state.rg_test_type);

            fd.append('IsPreOperativeTesting', this.state.IsPreOperativeTesting);
            fd.append('SurgeryCenterName', this.state.rg_surgery_center_name);
            fd.append('SurgeonName', this.state.rg_name_of_surgeon);
            fd.append('ProcedureDate', this.state.rg_procedure_date);



            fd.append('CreatedBy', 1);
            uploadImageFileFunction(fd, this.preRegistrationsResponse);
        }
        else {
            this.validator.showMessages();
        }
    }

    preRegistrationsResponse = (response) => {
        this.validator.hideMessages();
        if (response.data.success === 1) {
            this.growl.show({ severity: 'success', summary: 'Success', detail: response.data.message });
            setTimeout(() => window.location.reload(), 4000);
        } else {
            this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.message });
        }
        this.setState({ disabledButton: false, })
    }

    render() {
        if (this.state.showHideDocument !== 0) {
            this.validator.purgeFields();
        }
        return (
            <div>
                <Helmet>
                    <title>Genesis Laboratory Management</title>
                </Helmet>
                <HeaderRegistration logoName={'layout4/logo_gensys.png'} />
                <Growl ref={(el) => this.growl = el} />
                {/*Forget Password section*/}
                <section className=" contact-page section-b-space">
                    <div className="container">

                        <div className="row">
                            <div className="col-sm-12">
                                <form className="" onSubmit={this.submitRegistration}>
                                    <div className="form-row">

                                        <div className="col-md-12">
                                            <h3>Appointment Form</h3>
                                            <p> Please fill in the details below.</p>
                                            
                                        </div>

                                        <div className="col-md-12">
                                            <hr />
                                            <h3>Patient Information</h3>

                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="rg_name">Name <font className="required">*</font> {this.validator.message('name', this.state.rg_name, 'required|min:3|max:100')}</label>
                                            <input type="text"
                                                className="form-control"
                                                id="rg_name"
                                                value={this.state.rg_name}
                                                onChange={e => this.setState({ rg_name: e.target.value })}
                                            />

                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="rg_dob">DOB <font className="required">*</font>  {this.validator.message('date of birth', this.state.rg_dob, 'required')}</label>
                                            <Flatpickr
                                                className={"form-control"}
                                                name="rg_dob"
                                                options={{ dateFormat: "m-d-Y", maxDate: 'today' }}
                                                value={this.state.rg_dob}
                                                onBlur={e => this.setState({ rg_dob: e.target.value })}
                                            />

                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="rg_email">Email Id <font className="required">*</font> {this.validator.message('email', this.state.rg_email, 'required|email')}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="rg_email"
                                                value={this.state.rg_email}
                                                onChange={e => this.setState({ rg_email: e.target.value })}
                                            />

                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="rg_phone">Phone Number <font className="required">*</font> {this.validator.message('phone', this.state.rg_phone, 'required')}</label>
                                            <input type="text"
                                                className="form-control"
                                                id="rg_phone"
                                                value={this.state.rg_phone}
                                                onChange={e => this.setState({ rg_phone: e.target.value })}
                                            />

                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="rg_gender">Gender <font className="required">*</font> {this.validator.message('gender', this.state.rg_gender, 'required')}</label>
                                                <Select
                                                    name="rg_gender"
                                                    options={genderOptions}
                                                    value={this.state.valgender}
                                                    onChange={e => this.setState({ rg_gender: e.value, valgender: [{ label: e.label, value: e.value }] })}
                                                />
                                            </div>

                                        </div>


                                        <div className="col-md-4">
                                            <label htmlFor="rg_address">Address <font className="required">*</font> {this.validator.message('address', this.state.rg_address, 'required|min:5:max:200')}</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="rg_address"
                                                value={this.state.rg_address}
                                                onChange={e => this.setState({ rg_address: e.target.value })}
                                            ></textarea>

                                        </div>




                                        <div className="col-md-12">
                                            <hr />
                                            <h3>Insurance Information</h3>

                                        </div>
										<div className="col-md-12">
                                            <p>&nbsp;</p>
                                            <label className="checkbox-design">Cash Payment
                                            <input type="checkbox" name="rg_is_preoperative" value={this.state.rg_is_preoperative} onClick={this.handleIsOperative} /> <span className="checkmark" ></span></label>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="rg_insurance_image">Insurance Image</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="rg_insurance_image"
                                                accept="image/x-png,image/gif,image/jpeg"


                                                onChange={e => this.setState({ rg_insurance_image: e.target.files[0] })}
                                            />
                                            {/* {this.validator.message('insurance image', this.state.rg_insurance_image, 'required')} */}
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="rg_document_type">Document Type <font className="required">*</font> {this.validator.message('document type', this.state.rg_document_type, 'required')}</label>
                                                <Select
                                                    name="rg_document_type"
                                                    options={documentTypeOptions}
                                                    value={this.state.valDocumentType}
                                                    onChange={this.changeDocumentType}

                                                />
                                            </div>

                                        </div>
                                        {this.state.showHideDocument ?
                                            <div className="col-md-4">
                                                <label htmlFor="rg_ssn">SSN number <font className="required">*</font>

                                                    {
                                                        this.state.validateDocumentImage === 1 ?
                                                            this.validator.message('ssn number', this.state.actualSsn, 'required|ssn|min:9|max:9')
                                                            : null
                                                    }



                                                </label>
                                                <Input type="text"
                                                    name="rg_ssn"
                                                    id="rg_ssn"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    value={this.state.maskedSsn}
                                                    onChange={this.handleChangeSSN}
                                                   
                                                    
                                                />
                                                {/* <InputMask
                                                  
                                                  mask="999-99-9999"
                                                   maskChar={'*'}
                                                    className="form-control"
                                                    id="rg_ssn"
                                                    value={this.state.rg_ssn}
                                                    onChange={e => this.setState({ rg_ssn: e.target.value })}
                                                /> */}


                                            </div>
                                            :

                                            <div className="col-md-4">
                                                <label htmlFor="rg_document_type_image">Document Image <font className="required">*</font>
                                                    {
                                                        this.state.validateDocumentImage === 2 ?
                                                            this.validator.message('document image', this.state.rg_document_type_image, 'required')
                                                            : null
                                                    }
                                                </label>

                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="rg_document_type_image"
                                                    accept="image/x-png,image/gif,image/jpeg"
                                                    // value={this.state.rg_document_type_image}
                                                    onChange={e => this.setState({ rg_document_type_image: e.target.files[0] })} />

                                            </div>
                                        }


                                        <div className="col-md-12">
                                            <hr />
                                            <h3>Testing Information</h3>

                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="rg_test_location">Test Location <font className="required">*</font> {this.validator.message('test location', this.state.rg_test_location, 'required')}</label>
                                                <Select
                                                    name="rg_test_location"
                                                    options={locationOptions}

                                                    onChange={e => this.setState({ rg_test_location: e.value, valTestLocation: [{ label: e.label, value: e.value }] })}

                                                />
                                            </div>

                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="rg_phone">Referring Physician Name </label>
                                            <input type="text"
                                                className="form-control"
                                                id="rg_physician_name"
                                                value={this.state.rg_physician_name}
                                                onChange={e => this.setState({ rg_physician_name: e.target.value })}
                                            />

                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="rg_phone">Physician Center Name </label>
                                            <input type="text"
                                                className="form-control"
                                                id="rg_physician_center_name"
                                                value={this.state.rg_physician_center_name}
                                                onChange={e => this.setState({ rg_physician_center_name: e.target.value })}
                                            />

                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="rg_dob">Day for test <font className="required">*</font>  {this.validator.message('date for test', this.state.rg_test_day, 'required')}</label>
                                            <Flatpickr
                                                className={"form-control"}
                                                name="rg_test_day"
                                                options={{
                                                    minDate: "today", dateFormat: "m-d-Y", "disable": [
                                                        function (date) {
                                                            // return true to disable
                                                            return (date.getDay() === 0 || date.getDay() === 6);

                                                        }
                                                    ]
                                                }}
                                                value={this.state.rg_test_day}
                                                onBlur={e => this.setState({ rg_test_day: e.target.value })}
                                            />

                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="rg_test_time">Time for test <font className="required">*</font>  {this.validator.message('time for test', this.state.rg_test_time, 'required')}</label>
                                            <Flatpickr
                                                className={"form-control"}
                                                name="rg_test_time"
                                                options={{
                                                    enableTime: true,
                                                    noCalendar: true,
                                                    dateFormat: "H:i",
                                                    time_24hr: true,
                                                    minuteIncrement: 10,
                                                    // defaultDate: "09:15",
                                                    minTime: "09:15",
                                                    maxTime: "16:45",
                                                    clickOpens: true

                                                }}
                                                value={this.state.rg_test_time}
                                                onChange={this.handleTestingTime}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="rg_test_type">Select Test <font className="required">*</font> {this.validator.message('test type', this.state.rg_test_type, 'required')}</label>
                                                <Select
                                                    name="rg_test_type"
                                                    options={testTypeOptions}
                                                    value={this.state.valTestType}
                                                    onChange={e => this.setState({ rg_test_type: e.value, valTestType: [{ label: e.label, value: e.value }] })}

                                                />
                                            </div>

                                        </div>
                                       
                                        

                                        {/* <div className="col-md-6">
                                            <label htmlFor="rg_insurance">Insurance</label>
                                            <input type="text" className="form-control"
                                            />
                                            {this.validator.message('insurance', this.state.rg_insurance, 'required|min:3|max:50')}
                                        </div> */}


                                        <div className="col-md-12">
                                            <p>IMPORTANT:
                                            Please bring your health insurance card, a copy of the physician requisition and State ID at the time of your appointment.</p>

                                        </div>


                                        <div className="col-md-8">
                                            <label>

                                                <input
                                                    type="checkbox"
                                                    id="rg_consent_accept"
                                                    value={this.state.rg_consent_accept}
                                                    checked={this.state.rg_consent_accept_submit}
                                                    onChange={this.handleAggrement}

                                                /> I authorize Genesis Laboratory to contact me and understand that I may opt out at any time.</label>

                                            {this.state.rg_consent_accept === false ?
                                                this.validator.message('agreement', this.state.rg_consent_accept, 'accepted')
                                                : null
                                            }


                                        </div>
                                        <div className="col-md-4">
                                            <button className="btn btn-solid pull-right" type="submit" disabled={this.state.disabledButton}>Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <FooterCustom logoName={'layout4/logo_gensys.png'} />
            </div>
        )
    }
}

export default PreRegistration